/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ManagementBusinessEntityResponse } from './managementBusinessEntityResponse';

export interface ManagementBankruptcyResponse { 
    id: string;
    company?: ManagementBusinessEntityResponse;
    fileUrl?: string;
    phase?: ManagementBankruptcyResponse.PhaseEnum;
    publicationDate?: Date;
    text?: string;
    createdAt?: Date;
}
export namespace ManagementBankruptcyResponse {
    export type PhaseEnum = 'PRE_BANKRUPTCY' | 'BANKRUPTCY_PROCEEDINGS_OPEN' | 'CREDITORS_ASSEMBLY' | 'FILING_IN_BANKRUPTCY_FILE' | 'BANKRUPTCY_PROCEEDINGS_OPEN_CLOSE' | 'BANKRUPTCY_PROCEEDINGS_OPEN_CREDITORS_ASSEMBLY' | 'BANKRUPTCY_PROCEEDINGS_CLOSE' | 'SUSPEND_PRE_BANKRUPTCY' | 'BANKRUPTCY_TRUSTEE_CHANGE' | 'PROPERTY_SALE' | 'PROPERTY_ASSESSMENT' | 'PROCUREMENT_SERVICES_GOODS' | 'OTHER';
    export const PhaseEnum = {
        PREBANKRUPTCY: 'PRE_BANKRUPTCY' as PhaseEnum,
        BANKRUPTCYPROCEEDINGSOPEN: 'BANKRUPTCY_PROCEEDINGS_OPEN' as PhaseEnum,
        CREDITORSASSEMBLY: 'CREDITORS_ASSEMBLY' as PhaseEnum,
        FILINGINBANKRUPTCYFILE: 'FILING_IN_BANKRUPTCY_FILE' as PhaseEnum,
        BANKRUPTCYPROCEEDINGSOPENCLOSE: 'BANKRUPTCY_PROCEEDINGS_OPEN_CLOSE' as PhaseEnum,
        BANKRUPTCYPROCEEDINGSOPENCREDITORSASSEMBLY: 'BANKRUPTCY_PROCEEDINGS_OPEN_CREDITORS_ASSEMBLY' as PhaseEnum,
        BANKRUPTCYPROCEEDINGSCLOSE: 'BANKRUPTCY_PROCEEDINGS_CLOSE' as PhaseEnum,
        SUSPENDPREBANKRUPTCY: 'SUSPEND_PRE_BANKRUPTCY' as PhaseEnum,
        BANKRUPTCYTRUSTEECHANGE: 'BANKRUPTCY_TRUSTEE_CHANGE' as PhaseEnum,
        PROPERTYSALE: 'PROPERTY_SALE' as PhaseEnum,
        PROPERTYASSESSMENT: 'PROPERTY_ASSESSMENT' as PhaseEnum,
        PROCUREMENTSERVICESGOODS: 'PROCUREMENT_SERVICES_GOODS' as PhaseEnum,
        OTHER: 'OTHER' as PhaseEnum
    };
}